import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SWRConfig } from "swr";

import App from "@/app/App";
import { AuthProvider } from "@/app/providers/AuthProvider";
import { ToastProvider } from "@/app/providers/ToastProvider";
import { swrConfig } from "@/lib/swr";

import "./index.css";

const container = document.getElementById("root")!;
const app = (
  <StrictMode>
    <SWRConfig value={swrConfig}>
      <BrowserRouter>
        {/* Outside AuthProvider so the login screen can raise toasts too. */}
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </SWRConfig>
  </StrictMode>
);

if (import.meta.hot) {
  // import.meta.hot.data survives hot reloads, so the root is created once.
  const root = (import.meta.hot.data.root ??= createRoot(container));
  root.render(app);
} else {
  createRoot(container).render(app);
}
